if (!customElements.get('product-notification-modal')) {
  customElements.define(
    'product-notification-modal',
    class ProductNotificationModal extends HTMLElement {
      constructor() {
        super();
        this.productForm = null;
      }
      
      connectedCallback() {
        this.container = this.querySelector('.product-notification-modal__container');
        this.dialog = this.querySelector('[role="dialog"]');
        this.confirmButton = this.querySelector('[data-modal-confirm]');
        this.cancelButtons = this.querySelectorAll('[data-modal-cancel]');
        this.dontShowCheckbox = this.querySelector('[data-dont-show-again]');
        
        this.bindEvents();
      }
      
      bindEvents() {
        if (!this.confirmButton || !this.container) {
          return;
        }
        
        // Confirm button
        this.confirmButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.onConfirm();
        });
        
        // Cancel buttons
        this.cancelButtons.forEach((button) => {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.onCancel();
          });
        });
        
        // Click outside to close
        this.addEventListener('click', (e) => {
          if (e.target === this) {
            this.onCancel();
          }
        });
        
        // Prevent clicks inside dialog from bubbling
        if (this.dialog) {
          this.dialog.addEventListener('click', (event) => {
            event.stopPropagation();
          });
        }
        
        // ESC key to close
        this.escapeHandler = (event) => {
          if (event.key === 'Escape' && this.hasAttribute('open')) {
            this.onCancel();
          }
        };
        document.addEventListener('keydown', this.escapeHandler);
      }
      
      show(productForm) {
        this.productForm = productForm;
        if (this.dontShowCheckbox) {
          this.dontShowCheckbox.checked = false;
        }
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        document.body.style.overflow = 'hidden';
        
        // Focus the confirm button
        setTimeout(() => {
          if (this.confirmButton) {
            this.confirmButton.focus();
          }
        }, 100);
        
        // Trap focus within modal
        if (typeof trapFocus === 'function') {
          trapFocus(this.dialog, this.confirmButton);
        }
        
        // Pause all media
        if (window.pauseAllMedia) {
          window.pauseAllMedia();
        }
      }
      
      hide() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        document.body.style.overflow = '';
        
        // Remove focus trap
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(this.productForm ? this.productForm.submitButton : null);
        }
        
        this.productForm = null;
      }
      
      onConfirm() {
        if (this.productForm) {
          const productId = this.dataset.productId;
          if (productId && this.dontShowCheckbox && this.dontShowCheckbox.checked) {
            try {
              sessionStorage.setItem('product-notification-dismissed-' + productId, '1');
            } catch (e) {}
          }
          // Save reference before calling hide()
          const savedProductForm = this.productForm;
          const savedSubmitButton = this.productForm.submitButton;
          
          // Set confirmation flag
          savedProductForm.notificationConfirmed = true;
          
          // Close modal
          this.hide();
          
          // Resubmit the form
          setTimeout(() => {
            if (savedSubmitButton) {
              savedSubmitButton.click();
            } else {
              savedProductForm.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }
          }, 50);
        }
      }
      
      onCancel() {
        // Reset confirmation flag
        if (this.productForm) {
          this.productForm.notificationConfirmed = false;
        }
        this.hide();
      }
      
      disconnectedCallback() {
        // Clean up event listeners
        if (this.escapeHandler) {
          document.removeEventListener('keydown', this.escapeHandler);
        }
      }
    }
  );
}
